import { useEffect, useState } from "react";
import type { Termination } from "@rnavoyager/contracts";
import { listAdminTerminations, resolveTermination } from "./api";

/** 人工核实只提交精确绑定和证据摘要，不提供重新提交远端计算的入口。 */
export function TerminationAdmin() {
  const [rows, setRows] = useState<Termination[]>([]);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  async function reload() {
    try {
      setRows(await listAdminTerminations());
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "读取终止任务失败");
    }
  }
  useEffect(() => {
    void reload();
  }, []);
  return (
    <section className="user-admin">
      <h2>工具终止与人工核实</h2>
      <p>显示最近 100 个未完成终止任务。提交结果未知时，请先在外部服务核实，不要重新提交计算。</p>
      <button onClick={() => void reload()} disabled={busy}>
        刷新终止状态
      </button>
      {error && <p role="alert">{error}</p>}
      {rows.map((work) => (
        <article key={work.terminationId}>
          <h3>{work.sessionId}</h3>
          <p>
            {work.terminationId} · {work.state} · 未结束 {work.pending} · 待核实 {work.unknown}
          </p>
          {work.lastError && <p role="status">{work.lastError}</p>}
          <ul>
            {work.steps.map((step) => (
              <li key={step.stage}>
                {
                  {
                    local_stop: "本地停止",
                    remote_stop: "远端停止",
                    remote_status: "远端状态核验",
                    local_absent: "本地退出核验",
                  }[step.stage]
                }
                ：
                {step.state === "succeeded"
                  ? "已核验"
                  : `失败（${step.detailCode ?? step.errorCode}）`}
                {step.requestId && <small> · 请求 {step.requestId}</small>}
              </li>
            ))}
          </ul>
          {work.resources
            .filter((resource) => resource.state === "unknown")
            .map((resource) => (
              <form
                key={resource.grantId}
                onSubmit={(event) => {
                  void (async () => {
                    event.preventDefault();
                    const data = new FormData(event.currentTarget);
                    const resourceId = String(data.get("resourceId") ?? "").trim();
                    const noJob = data.get("noJob") === "on";
                    if (Boolean(resourceId) === noJob) {
                      setError("请填写精确任务 ID，或勾选已确认没有创建任务，二选一。");
                      return;
                    }
                    if (
                      !window.confirm(
                        noJob
                          ? "确认已有证据证明该提交没有创建任何远端任务？"
                          : "确认此任务 ID 属于该 Grant？提交后平台将取消该任务。",
                      )
                    )
                      return;
                    setBusy(true);
                    setError("");
                    try {
                      await resolveTermination(work.terminationId, {
                        grantId: resource.grantId,
                        resourceId: noJob ? null : resourceId,
                        evidenceDigest: String(data.get("evidenceDigest")),
                      });
                      await reload();
                    } catch (cause) {
                      setError(cause instanceof Error ? cause.message : "核实失败");
                    } finally {
                      setBusy(false);
                    }
                  })();
                }}
              >
                <p>创建 Grant：{resource.grantId}</p>
                <label>
                  精确远端任务 ID <input name="resourceId" maxLength={128} disabled={busy} />
                </label>
                <label>
                  <input name="noJob" type="checkbox" disabled={busy} /> 已有证据确认未创建任务
                </label>
                <label>
                  核实证据 SHA-256{" "}
                  <input
                    name="evidenceDigest"
                    required
                    pattern="[a-f0-9]{64}"
                    maxLength={64}
                    disabled={busy}
                  />
                </label>
                <button type="submit" disabled={busy || work.state !== "needs_attention"}>
                  提交核实并继续终止
                </button>
              </form>
            ))}
        </article>
      ))}
    </section>
  );
}
